
import BaseCmsBlock from '../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin';
export default BaseCmsBlock.extend({
  name: 'VacanciesLast5YearsBlock',

  data() {
    return {
      windowWidth: null,
    }
  },
  computed: {
    localValues: function () {
      return this.externalData?.VacanciesLast5YearsBlock || this.values || {}; // @FIXME ПРОВЕРЬ!
    },
    isMobile: function () {
      if (!process.client) {
        return false;
      }
      return this.windowWidth < 839;
    }
  },
  methods: {
    handleWindowSize() {
      if (!process.client) {
        return;
      }
      this.windowWidth = window.innerWidth;
    },
  },
  mounted: function () {
    this.windowWidth = window.innerWidth;
    window.addEventListener('resize', this.handleWindowSize);
  },
  unmounted: function () {
    window.removeEventListener('resize', this.handleWindowSize);
  },
});
